import { Component, inject } from '@angular/core';
import { ProcessPerProfileService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  ProcessPerProfileCreateDto,
  ProcessPerProfileDto,
  ProcessPerProfileExcelDownloadDto,
  ProcessPerProfileUpdateDto,
} from '../proxy/controlling/dtos/process-per-profile';
import { PROCESSPERPROFILE_CONFIG, PROCESSPERPROFILE_FIELDS } from './process-per-profile.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-process-per-profile',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, ProcessPerProfileService, ConfirmationService],
  templateUrl: './process-per-profile.html',
  styleUrl: './process-per-profile.scss',
})
export class ProcessPerProfile extends BaseCrudComponent<
  ProcessPerProfileDto,
  ProcessPerProfileCreateDto,
  ProcessPerProfileUpdateDto,
  ProcessPerProfileExcelDownloadDto
> {
  service = inject(ProcessPerProfileService);
  config = PROCESSPERPROFILE_CONFIG;
  fields = PROCESSPERPROFILE_FIELDS;

  protected prepareUpdateDto(data: any, selected: ProcessPerProfileDto): ProcessPerProfileUpdateDto {
    return {
      isApprover: data.isApprover,
      processId: data.processId,
      profileId: data.profileId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'ProcessPerProfile';
  }
}
